import { render } from "./MigrationsList.vue?vue&type=template&id=3c6480d1&ts=true"
import script from "./MigrationsList.vue?vue&type=script&lang=ts"
export * from "./MigrationsList.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__